import { useEventHook } from '@goodt-common/utils';

const PRIVATE_ERROR_HOOK = Symbol('ErrorNotifyTrait._errorHook');
const ERROR_HOOK = Symbol('ErrorNotifyTrait.errorHook');
/**
 * @class
 */
export class ErrorNotifyTrait {
    /**
     * @type {typeof ReturnType<useEventHook>}
     */
    get [ERROR_HOOK]() {
        return (this[PRIVATE_ERROR_HOOK] ??= useEventHook());
    }

    /**
     * @param {Error} error
     */
    notifyError(error) {
        this[ERROR_HOOK].trigger(error);
    }

    /**
     * @param {function(error: Error): void} handler
     * @return {function(): void}
     */
    addErrorHandler(handler) {
        if (typeof handler !== 'function') {
            throw new TypeError('handler must be a function');
        }
        return this[ERROR_HOOK].on(handler).off;
    }
}
